module.exports = {
	factory: require('./factory'),
	parse: require('./parse'),
	Entity: require('./Entity')
};

